// Spanish — mirrors src/i18n/local/en/common.ts for Spanish-speaking buyers (ES/LATAM).

const common = {
  "nav.home": "Inicio",
  "nav.products": "Productos",
  "nav.factory": "Fábrica",
  "nav.about": "Nosotros",
  "nav.contact": "Contacto",
  "nav.requestQuote": "Solicitar cotización",
  "nav.menu": "Menú",
  "nav.language": "Idioma",

  "cta.requestQuote": "Solicitar cotización",
  "cta.exploreCatalog": "Explorar catálogo",
  "cta.contactUs": "Contáctanos",
  "cta.scheduleFactoryVisit": "Agendar visita a la fábrica",
  "cta.requestSample": "Solicitar muestra",
  "cta.viewAll": "Ver todos los productos",

  "common.tbd": "[Por confirmar por Forwaro]",
  "common.category": "Categoría",
  "common.material": "Material",
  "common.style": "Estilo",
  "common.filters": "Filtros",
  "common.resetAll": "Restablecer",
  "common.details": "Detalles",

  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",
  "whatsapp.cta": "Escríbenos por WhatsApp",
  "wechat.cta": "Añádenos en WeChat",

  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "El hogar es",
  "home.hero.headline.line2Highlight": "el centro de todo",
  "home.hero.headline.line3": "en una vida ocupada.",
  "home.hero.subheadline": "Forwaro Furniture (風華國際) es un fabricante OEM / ODM con sede en Dongguan que combina el diseño de mobiliario con una calidad de producción constante para importadores de Oriente Medio, Europa, América y Asia.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "Líneas de productos",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "Producción a medida",
  "home.hero.stat3.value": "Dongguan",
  "home.hero.stat3.label": "Zona industrial de Min Tian",
  "home.hero.stat4.value": "Global",
  "home.hero.stat4.label": "Alianzas para exportación",
  "home.hero.scroll": "Desplazar",

  "home.categories.kicker": "Nuestra gama",
  "home.categories.heading": "Seis líneas de productos, una fábrica de confianza",
  "home.categories.description": "Mesas de comedor, mesas de centro, consolas, sillas, sofás y muebles de TV: las seis líneas de mobiliario B2B que Forwaro produce para exportación.",

  "home.about.kicker": "Sobre Forwaro",
  "home.about.heading.line1": "Diseño de mobiliario,",
  "home.about.heading.line2": "con oficio constante.",
  "home.about.philosophy.en":
    "El hogar es el centro de una vida ajetreada, donde la estética del hábitat se convierte en el gusto y la búsqueda de quienes prosperan. Forwaro Furniture mantiene una coherencia de diseño y calidad para que estética y artesanía se complementen en cada hogar.",
  "home.about.location": "Forwaro Furniture (風華國際有限公司) fue fundada en Taiwan en 1991 y fabrica en China continental desde 2006. Hoy opera desde la Min Tian Industrial Zone, en Shatian Town, Dongguan. Forwaro colabora con importadores que valoran la artesanía honesta y las entregas fiables.",
  "home.about.highlight1.title": "OEM y ODM",
  "home.about.highlight1.body":
    "Producción a medida — desde marca blanca hasta diseño e ingeniería completos.",
  "home.about.highlight2.title": "Control de calidad exportador",
  "home.about.highlight2.body":
    "Inspección en carpintería, tapicería, acabados y empaque para transporte transoceánico.",
  "home.about.highlight3.title": "Mármol natural y acero",
  "home.about.highlight3.body": "Superficies distintivas en mármol natural, combinadas con bases de acero inoxidable electrochapado y hierro.",
  "home.about.highlight4.title": "Alcance global",
  "home.about.highlight4.body": "Desde Dongguan, atendemos a importadores de Oriente Medio, Europa, América y Asia.",
  "home.about.badgeLocation": "Dongguan, China",
  "home.about.badgeZone": "Zona industrial Min Tian",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "A medida y marca blanca",

  "home.featured.kicker": "Vista previa del catálogo",
  "home.featured.heading": "Un adelanto de las seis líneas de Forwaro",
  "home.featured.description": "Códigos de modelo Forwaro auténticos, con materiales y dimensiones confirmados. Contáctenos para obtener las especificaciones completas y un presupuesto.",


  "home.markets.kicker": "Alcance global",
  "home.markets.heading": "Mercados a los que exportamos",
  "home.markets.description":
    "Forwaro colabora con importadores, distribuidores, grupos de hospitalidad y proyectos residenciales en cuatro continentes.",

  "home.process.heading": "Cómo trabajamos contigo",
  "home.process.description":
    "Desde la primera consulta hasta la carga del contenedor — el flujo de exportación estándar de Forwaro.",

  "footer.getInTouch.kicker": "Contáctanos",
  "footer.getInTouch.heading":
    "Comienza tu importación de muebles\ncon Forwaro",
  "footer.getInTouch.description":
    "Nuestro equipo de exportación entrega cotizaciones personalizadas, muestras y documentación completa para tu mercado.",
  "footer.contact.email": "Correo electrónico",
  "footer.contact.phone": "Teléfono",
  "footer.contact.fax": "Fax",
  "footer.contact.factory": "Fábrica",
  "footer.contact.whatsappNote":
    "Canales WhatsApp y WeChat — por confirmar por Forwaro.",
  "footer.form.heading": "Solicitar cotización",
  "footer.form.name": "Nombre completo",
  "footer.form.email": "Correo electrónico",
  "footer.form.company": "Empresa",
  "footer.form.country": "País",
  "footer.form.countryPlaceholder": "Selecciona un país",
  "footer.form.message": "Mensaje",
  "footer.form.messagePlaceholder":
    "Describe tus requisitos, cantidades y mercado objetivo…",
  "footer.form.submit": "Enviar consulta",
  "footer.form.sending": "Enviando…",
  "footer.form.success.heading": "¡Enviado!",
  "footer.form.success.body":
    "Nuestro equipo export responderá en dos días hábiles.",
  "footer.form.sendAnother": "Enviar otro mensaje",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱. Fabricante OEM/ODM con sede en Dongguan, al servicio de importadores de Oriente Medio, Europa, América y Asia.",
  "footer.col.products": "Productos",
  "footer.col.company": "Empresa",
  "footer.col.markets": "Mercados de exportación",
  "footer.col.regional": "¿Buscas un representante regional?",
  "footer.copyright": "Todos los derechos reservados.",
};

export default common;
